module.exports = __webpack_public_path__ + "media/images/application/template/plus-grey-46be3673d3e676f0dcaad241ea392f61.svg";